import Process from "./Process";

export default function Services() {
  const services = [
    {
      title: "Custom Software Development",
      desc: "Scalable, secure, and business-focused software solutions using .NET and modern architectures.",
      icon: "bi-code-slash",
    },
    {
      title: "POS & ERP Systems",
      desc: "End-to-end POS, ERP, inventory, and accounting systems tailored to your workflow.",
      icon: "bi-cash-stack",
    },
    {
      title: "Web & E-Commerce",
      desc: "Fast, SEO-friendly websites and e-commerce platforms built for conversions.",
      icon: "bi-globe",
    },
    {
      title: "Cloud & API Solutions",
      desc: "Cloud-ready APIs, integrations, and microservices for long-term growth.",
      icon: "bi-cloud",
    },
  ];

  return (
    <>
      <section id="services" className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center fw-bold mb-4">Our Services</h2>

          <div className="row g-4">
            {services.map((s, i) => (
              <div className="col-md-6 col-lg-3" key={i}>
                <div className="card h-100 shadow-sm text-center p-3">
                  <i className={`bi ${s.icon} fs-1 text-warning mb-3`}></i>
                  <h5 className="fw-semibold">{s.title}</h5>
                  <p className="text-muted small">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Process />
    </>
  );
}
